import React, { ReactNode } from "react"
import { Platform, ScrollViewProps } from "react-native"
import { EdgeInsets, useSafeAreaInsets } from "react-native-safe-area-context"

import styled from "styled-components/native"

import {
  ListViewProps as ListViewPropsOriginal,
  ListViewRef,
} from "../../../components/list-view"
import {
  backgroundColorToString,
  BackgroundColor,
} from "../../../lib/background-color"
import { withUnits } from "../../../lib/with-units"

export type ListViewProps<ListViewItem = unknown> = Omit<
  ListViewPropsOriginal<ListViewItem>,
  "viewSize"
> & {
  key?: string
  ref?: React.Ref<ListViewRef<ListViewItem>>
}

export type ScrollableLayoutProps<ListViewItem = unknown> = {
  children?: ReactNode
  header?: ReactNode
  footer?: ReactNode
  keyboardDismissMode?: ScrollViewProps["keyboardDismissMode"]
  contentContainerStyle?: ScrollViewProps["contentContainerStyle"]
  headerHeight?: number
  footerHeight?: number
  backgroundColor?: BackgroundColor
  listViewProps?: ListViewProps<ListViewItem>
}

export const DEFAULT_SCROLL_EVENT_THROTTLE = 8

export const DEFAULT_RENDER_AHEAD_OFFSET = 240

const FixedContainer = styled.View<{
  $top?: number
  $bottom?: number
}>`
  position: ${Platform.OS === "web" ? "fixed" : "absolute"};
  z-index: 1;
  width: 100%;
  left: 0px;
  top: ${(props) => withUnits(props.$top)};
  bottom: ${(props) => withUnits(props.$bottom)};
`

const StaticContainer = styled.View<{
  $insets: EdgeInsets
  $backgroundColor: BackgroundColor
}>`
  position: relative;
  flex: auto;
  background: ${(props) =>
    backgroundColorToString(props.theme, props.$backgroundColor)};
  padding-left: ${(props) => props.$insets.left}px;
  padding-right: ${(props) => props.$insets.right}px;
  width: 100%;
`

export function PageContainer(props: {
  children: ReactNode
  backgroundColor: BackgroundColor
}): React.JSX.Element {
  const insets = useSafeAreaInsets()
  return (
    <StaticContainer $backgroundColor={props.backgroundColor} $insets={insets}>
      {props.children}
    </StaticContainer>
  )
}

export function HeaderContainer(props: {
  children: ReactNode
}): React.JSX.Element {
  return <FixedContainer {...props} pointerEvents="box-none" $top={0} />
}

export function FooterContainer(props: {
  children: ReactNode
}): React.JSX.Element {
  return <FixedContainer {...props} pointerEvents="box-none" $bottom={0} />
}
